import React from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '@store/store';
import getEmployee from '@src/APIs/graphQl/Employee/getEmployee';
import EmployeePage from '@src/App/NewLayout/Pages/Employees/EmployeePage/EmployeePage';

import Overlay from '../Overlay/Overlay';

import './EmployeeOverlay.css';

interface EmployeeOverlayProps
{
    employeeId: number;
    children: React.ReactNode;
    disabled?: boolean;
}

/**
 * EmployeeOverlay function component.
 * @param {EmployeeOverlayProps} props - The props object for the EmployeeOverlay component.
 * @returns {JSX.Element} The rendered EmployeeOverlay component.
 */
function EmployeeOverlay(props: EmployeeOverlayProps)
{
    const employee = useSelector((state: AppState) => state.employees.find(e => e.id === props.employeeId));
    const [error, setError] = React.useState<Error | null>(null);
    return (
        <Overlay
            loaded={employee !== undefined}
            disabled={props.disabled}
            triggerItem={props.children}
            error={error}
            onFirstOpen={() =>
            {
                getEmployee(props.employeeId)
                    .catch(setError);
            }}>
            {employee && <EmployeePage entity={employee} inDialog={true} />}
        </Overlay>
    );
}

export default EmployeeOverlay;
